import { useEffect, useState } from "react"

import {
  Paper,
  Tooltip,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material"

import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { setCurRightPage } from "../udTreatSlice"
import { useTheme } from "@mui/material/styles"
import { toothMovement, wasmModule } from "@/gluelayer"

import NewAuxIcon from "../assets/right/attachment.svg"
import SetupIcon from "../assets/right/setup.svg"
import StagingIcon from "../assets/right/staging.svg"

import { ReactSVG } from "react-svg"
import SCCallbackManager from "../bottom/StageBar/stageCommon"

export function RightToolBar(props: any) {
  const theme = useTheme()
  const { curRightPage, switchViewEdit, isCasePreview } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)

  const dispatch = useAppDispatch()
  const [fastsmartAlert, setFastsmartAlert] = useState(false)
  const { curArch, openHistorySplitView, openBiteCheck, stageShowIpr } =
    useAppSelector((state: RootState) => state.udTreatService)
  const handleChange = async (
    event: React.MouseEvent<HTMLElement>,
    nextTool: string,
  ) => {
    if (curRightPage === "QuickStaging") {
      if (
        SCCallbackManager.getInstance().getAsyncCheckingBeforeQuitIprCallBack()
      ) {
        const checkResult =
          await SCCallbackManager.getInstance().getAsyncCheckingBeforeQuitIprCallBack()()
        if (checkResult === "cancel") {
          return
        }
        if (SCCallbackManager.getInstance().getAsyncQuitStagingCallBack()) {
          await SCCallbackManager.getInstance().getAsyncQuitStagingCallBack()()
        }
      }
    }

    dispatch(setCurRightPage(nextTool))
  }

  useEffect(() => {
    if (openBiteCheck) {
      if (curRightPage === "fastsmart" || curRightPage === "finetune") {
        dispatch(setCurRightPage(""))
      }
    }
  }, [openBiteCheck])

  useEffect(() => {
    dispatch(setCurRightPage(""))

    if (!switchViewEdit && wasmModule.isFinishedOpencase) {
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
    }
  }, [switchViewEdit])
  return (
    !openHistorySplitView && (
      <Paper
        sx={{
          right: 16,
          top: 133,
          backgroundColor: theme.transBkColor.light,
          maxHeight: `calc(100% - 114px)`,
          overflow: "auto",
          "::-webkit-scrollbar": {
            width: "1px",
          },
          position: "absolute",
          borderRadius: "8px",
        }}
        elevation={6}
      >
        {switchViewEdit &&
          !isCasePreview &&
          caseDetail.caseDisposition !== "ATTENTION_NEEDED" && (
            <ToggleButtonGroup
              orientation="vertical"
              value={curRightPage}
              exclusive
              onChange={handleChange}
            >
              <Tooltip title="Setup" placement="left">
                <ToggleButton
                  value="UDSetup"
                  sx={{
                    textTransform: "none",
                    width: "48px",
                    border: "none",
                    flexWrap: "wrap",
                    borderRadius: "8px",
                    "&:hover": {
                      borderRadius: "8px",
                    },
                    "&.Mui-selected": {
                      borderRadius: "8px",
                    },
                    // marginTop: "8px",
                  }}
                >
                  <ReactSVG
                    src={SetupIcon}
                    afterInjection={(svg) => {
                      const path = svg.getElementsByTagName("path")[0]
                      const path1 = svg.getElementsByTagName("path")[1]
                      if (curRightPage === "UDSetup") {
                        path?.setAttribute("fill", "#215ECD")
                        path1?.setAttribute("fill", "#215ECD")
                        path?.setAttribute("fill-opacity", "1")
                        path1?.setAttribute("fill-opacity", "1")
                      }
                    }}
                  ></ReactSVG>
                  {/* <Typography
                    variant="inherit"
                    sx={{ fontSize: "11px", color: "rgba(96, 96, 96, 1)" }}
                  >
                    Setup
                  </Typography> */}
                </ToggleButton>
              </Tooltip>
              <Tooltip title="Staging" placement="left">
                <ToggleButton
                  value="QuickStaging"
                  sx={{
                    textTransform: "none",
                    width: "48px",
                    flexWrap: "wrap",
                    border: "none",
                    borderRadius: "8px",
                    "&:hover": {
                      borderRadius: "8px",
                    },
                    "&.Mui-selected": {
                      borderRadius: "8px",
                    },
                  }}
                >
                  <ReactSVG
                    src={StagingIcon}
                    afterInjection={(svg) => {
                      const path = svg.getElementsByTagName("path")[0]
                      if (curRightPage === "QuickStaging") {
                        path?.setAttribute("fill", "#215ECD")
                        path?.setAttribute("fill-opacity", "1")
                      }
                      // else {
                      //   path?.setAttribute("fill", "black")
                      //   path?.setAttribute("fill-opacity", "0.56")
                      // }
                    }}
                  ></ReactSVG>
                  {/* <Typography
                    variant="inherit"
                    sx={{ fontSize: "11px", color: "rgba(96, 96, 96, 1)" }}
                  >
                    Staging
                  </Typography> */}
                </ToggleButton>
              </Tooltip>
              <Tooltip title="UD Auxillary" placement="left">
                <ToggleButton
                  value="UDAux"
                  sx={{
                    border: "none",
                    borderRadius: "8px",
                    "&:hover": {
                      borderRadius: "8px",
                    },
                    "&.Mui-selected": {
                      borderRadius: "8px",
                    },
                  }}
                >
                  <ReactSVG
                    src={NewAuxIcon}
                    afterInjection={(svg) => {
                      const path = svg.getElementsByTagName("path")[0]
                      if (curRightPage === "UDAux") {
                        path?.setAttribute("fill", "#215ECD")
                        path?.setAttribute("fill-opacity", "1")
                      } else {
                        path?.setAttribute("fill", "black")
                        path?.setAttribute("fill-opacity", "0.56")
                      }
                    }}
                  ></ReactSVG>
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          )}
        <Dialog open={fastsmartAlert}>
          {/* <DialogTitle></DialogTitle> */}
          <DialogContent>
            Please select a single arch to use this function.
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setFastsmartAlert(false)
              }}
              sx={{
                textTransform: "uppercase",
              }}
              size="medium"
              variant="contained"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    )
  )
}
